export default __webpack_public_path__ + "static/media/the_pope_video_fr.72009366.svg";